import React, { useEffect, useState } from 'react';
import { useProgress } from '@react-three/drei';

// A brief, premium branded splash: the gold TAB seal over the dark biome while
// the world's assets load. Fades out once loading settles (min ~1.4s on screen).
export default function SealSplash() {
  const { progress, active } = useProgress();
  const [visible, setVisible] = useState(true);
  const [minDone, setMinDone] = useState(false);

  useEffect(() => {
    // Returning visitors get a much shorter splash so repeat entries feel instant.
    let returning = false;
    try { returning = localStorage.getItem('jb_visited') === '1'; localStorage.setItem('jb_visited', '1'); } catch (e) {}
    const t = setTimeout(() => setMinDone(true), returning ? 450 : 1400);
    return () => clearTimeout(t);
  }, []);

  // This scene is fully procedural (no GLTF/textures), so `progress` may stay at 0
  // and `active` stays false — fade once the minimum splash time passes and nothing
  // is actively loading. A hard 6s safety net guarantees it can never hang.
  const ready = minDone && !active;
  useEffect(() => {
    if (ready) {
      const t = setTimeout(() => setVisible(false), 700);
      return () => clearTimeout(t);
    }
  }, [ready]);
  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 6000);
    return () => clearTimeout(t);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="seal-splash"
      className="fixed inset-0 z-[300] flex flex-col items-center justify-center"
      style={{ background: '#04060b', transition: 'opacity 0.7s ease', opacity: ready ? 0 : 1, pointerEvents: 'none' }}
    >
      <div className="relative flex flex-col items-center gap-6 animate-hud-in">
        <div className="absolute -inset-12 rounded-full" style={{ background: 'radial-gradient(circle, rgba(212,175,55,0.20), transparent 70%)', filter: 'blur(10px)' }} />
        <img src="/tab-seal.png" alt="The Academic Boardroom" className="w-40 h-40 object-contain animate-pulse-gold relative" />
        <div className="text-center relative">
          <div className="font-serif text-2xl text-white tracking-tight">
            The Jungle <span className="italic text-gold">of</span> Bias
          </div>
          <div className="font-mono text-[9px] uppercase tracking-[0.4em] text-white/40 mt-2">A Spatial Simulation</div>
        </div>
        <div className="w-56 h-[3px] rounded-full bg-white/10 overflow-hidden relative">
          <div className="h-full bg-gold transition-all duration-300" style={{ width: `${Math.max(6, progress)}%` }} />
        </div>
        <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold/70 relative">
          Entering the biome · {progress.toFixed(0)}%
        </div>
      </div>
    </div>
  );
}
